const AppraiserAppraisalsDataMapper = {
  appraisalToTable: (appraisal, actionType) => ({
    ...appraisal,
    key: appraisal.id,
    action: actionType
  })
};

export default AppraiserAppraisalsDataMapper;
